import { z } from 'zod'
import { LINK_SOURCES } from '../enums'
import { id, optionalEmail, optionalText, requiredText } from './common'

export const contactInputSchema = z.object({
  name: requiredText(200, 'שם איש הקשר הוא שדה חובה'),
  email: optionalEmail(),
})

export type ContactInput = z.infer<typeof contactInputSchema>

export const contactQuerySchema = z.object({
  search: optionalText(200),
})

/** Attaching an existing contact to a project or a case, with the role it plays there. */
export const contactLinkSchema = z.object({
  contactId: id(),
  role: optionalText(120),
})

export type ContactLinkInput = z.infer<typeof contactLinkSchema>

export type ContactDto = {
  id: string
  name: string
  email: string | null
  createdAt: string
  updatedAt: string
  linkCount?: number
}

/** A contact as shown on a case: either inherited from the project or linked directly. */
export type LinkedContactDto = ContactDto & {
  role: string | null
  source: (typeof LINK_SOURCES)[number]
  removable: boolean
}
